export default "__VITE_ASSET__CE7pyZpr__"